export default __webpack_public_path__ + "static/media/companyLogo.77904929.png";